import React from 'react';
import { Link } from 'react-router-dom';
import Iftar2025 from '../../assets/audio/images/iftar20251.jpg';
import NavbarAll from '../Navbar/NavbarAll';

const EventDetail = () => {
  return (
    <>
    <NavbarAll />
    <div >
      {/* Hero Section (unchanged) */}
      <section className="w-100 pt-80 pb-70 black-layer position-relative">
        <div
          className="fixed-bg"
          style={{
            backgroundImage: `url(${Iftar2025})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        ></div>
        <div className="container">
          <div className="page-title-wrap text-center w-100">
            <div className="page-title-inner d-inline-block">
              <h1 className="mb-0 text-white text-5xl font-bold">Iftar-O-Clock 2.0</h1>
              <p className="text-white text-lg mt-2">Join us for a spiritual and engaging evening!</p>
            </div>
          </div>
        </div>
      </section>

      {/* Event Details Section */}
      <section style={{ width: '100%', padding: '20px 0' }}>
        <div
          style={{
            maxWidth: '1100px',
            margin: '0 auto',
            padding: '20px',
            backgroundColor: '#fff',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
            borderRadius: '16px',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '20px',
          }}
        >
          {/* Image Card */}
          <div
            style={{
              flex: '1',
              minWidth: '300px',
              maxWidth: '400px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                width: '100%',
                height: '400px',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              }}
            >
              <img
                src={Iftar2025}
                alt="Iftar 2025"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
          </div>

          {/* Event Details */}
          <div
            style={{
              flex: '2',
              minWidth: '300px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <h2 style={{ fontSize: '32px', fontWeight: 'bold', color: '#2563eb', marginBottom: '20px' }}>Iftar O'Clock 2.0</h2>
            <p style={{ color: '#4b5563', marginBottom: '10px' }}><strong>📅 Date:</strong> 16th March 2025</p>
            <p style={{ color: '#4b5563', marginBottom: '20px' }}><strong>📍 Location:</strong> Masjid Zakaria, 109 26th Street, DHA Phase 8, Karachi</p>

            <p style={{ color: '#374151', marginBottom: '20px' }}>
              Asalamualikum WRB, <br />
              Join us for a meaningful and engaging evening at Masjid e Zakaria, designed especially for boys aged 6-14.
              This event will take place on <span style={{ color: '#10b981', fontWeight: '600' }}>Sunday, 16th March</span> between Asr and Maghrib.
            </p>

            <div style={{ marginBottom: '20px' }}>
              <h3 style={{ fontWeight: '600', color: '#9333ea' }}>📖 What to Expect:</h3>
              <ul style={{ paddingLeft: '20px', color: '#1f2937' }}>
                <li>A short talk to help children understand the virtues of Ramzan</li>
                <li>Exciting quizzes with prizes</li>
                <li>Special gift for any child keeping their first-ever Roza</li>
                <li>A chance to experience the beautiful masjid environment</li>
              </ul>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <h3 style={{ fontWeight: '600', color: '#ef4444' }}>🥤 Iftari Details:</h3>
              <ul style={{ paddingLeft: '20px', color: '#1f2937' }}>
                <li>Students must bring their own iftari.</li>
                <li>The masjid will provide dates and drinks.</li>
              </ul>
            </div>

            <p style={{ color: '#f97316', marginBottom: '20px' }}>
              👨‍👦 Parents are encouraged to send their boys to help build a connection with the masjid and develop a love for this blessed month.
            </p>

            {/* Learn More Button */}
            <div style={{ marginTop: 'auto', textAlign: 'center' }}>
              <Link
                to="https://forms.gle/XmTqu7nrpQYn4zXh9"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  padding: '12px 24px',
                  background: 'linear-gradient(to right, #3b82f6, #6366f1)',
                  color: '#fff',
                  fontWeight: '600',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  transition: 'transform 0.3s ease',
                }}
                onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
              >
                Register Now
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  );
};

export default EventDetail;
